import React, { useEffect, useState } from "react";
import { CpnwContainer } from "hooks/useCpnw";
import DashboardClinicalRosterTable from "components/DashboardClinicalRosterTable";

import styles from "./HcClinicalRoster.module.css";

const HcClinicalRoster = () => {
  const {
    reportData,
  } = CpnwContainer.useContainer();

  const [reports, setReports] = useState([]);

  useEffect(() => {
    if (reportData && reportData.total > 0) {
      setReports([...reportData.data]);
    }
  }, [reportData]);


  return (
    <div className={styles.container}>
      <h1>Clinical Rosters</h1>
      <div className={styles.content}>
        {reports?.length > 0 ? (
          <DashboardClinicalRosterTable items={mapReports(reports)} />
        ) : null}
      </div>
    </div>
  );
};

const mapReports = (reports) => {
  let result = (reports || []).map((m) => {
    return {
      // id:m.Assignment?.AssignmentIDpk,
      id: m.ContactIDPK,
      assignmentId: m.Assignment?.AssignmentIDpk,
      // assignmentStatus: getAssignmentStatusTypes(m.Assignment?.Status),
      // rejectionContent: m.Assignment?.RejectionReasons,
      contact: {
        id: m.ContactIDPK,
        name: m.NameLast + ", " + m.NameFirst,
        email: m.email,
        phone: m.PrimaryPhone,
        // address: m.address,
        emergencyContact: m.EmergencyContact,
        emergencyContactPhone: m.EmergencyPhone,
        school: m.EDFacilityName,
        program: m.BusinessUnitName,
        sIDEID: m.IndividualID,
        location: m.Assignment?.HCFacilityName,
        startDate: m.Assignment?.StartDate,
        ssn: m.SSN,
      },
      ad: m.ContactIDPK,
      oig: m.OIGResult,
      sam: m.SAMResult,
      userType: m.TypeContact,
      // userRequirements: m.userRequirements,
      name: m.NameLast + ", " + m.NameFirst,
      location: m.Assignment?.HCFacilityName,
      startDate: m.Assignment?.StartDate,
      endDate: m.Assignment?.EndDate,
      school: m.EDFacilityName,
      program: m.BusinessUnitName,
      type: m.TypeContact,
    };
  });

  return result;
};

export default HcClinicalRoster;
